import * as types from '../mutations-types'

// initial state
// shape: [{ id, quantity }]
const state = {
  salaryPopEventData: {},
  salaryScheme: {}
}

// actions
const actions = {}

// mutations
const mutations = {
  [types.SET_SALARYSCHEME](state, data) {
    state.salaryScheme = data
  },
  [types.SALARY_POP_EVENT_DATA](state, data) {
    state.salaryPopEventData = data
  }
}
// getters
const getters = {
  getSalaryScheme: state => index => {
    return state.salaryScheme
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
